export default {
    url: '/total',
    template: require('./view.html'),
    data: {
        title: 'Total',
        role: 'video',
        priority: 801,
    },
    reloadOnSearch: false,
};
